import { Box, useTheme } from '@mui/material'
import { memo } from 'react'
import SumsubWebSdk from '@sumsub/websdk-react'

import Popup from '../../shared/popup/Popup'
import { LANGUAGE_EN } from '../../../util/translation.helpers'
import { LoadingScreen } from '../../shared/loading-screen'

const KycFrame = ({
  onCancel,
  loading,
  accessToken,
  expirationHandler,
  onError,
  onMessage
}) => {
  const theme = useTheme()
  return (
    <Popup onCancel={onCancel} disableClose customClose maxWidth='sm'>
      {loading ? (
        <Box sx={{ minHeight: 150, mb: 2, mt: 2 }}>
          <LoadingScreen />
        </Box>
      ) : (
        <SumsubWebSdk
          accessToken={accessToken}
          expirationHandler={expirationHandler}
          config={{
            lang: LANGUAGE_EN,
            uiConf: {
              theme: theme.palette.mode
            }
          }}
          options={{
            adaptIframeHeight: true,
            addViewportTag: false
          }}
          onMessage={onMessage}
          onError={onError}
        />
      )}
    </Popup>
  )
}

export default memo(KycFrame)
